module.exports = __webpack_public_path__ + "img/email_updated_light.80bb6bc0.svg";